import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_557ocq7k0h: FaireBrandEntity = {
  token: "b_557ocq7k0h",
  type: "brand",
  name: "Allegheny Outfitters",
  avatarUrl:
    "https://cdn.faire.com/fastly/26686224aab9560ece6c58ab2370d4a34584ae3eb173400e691d2490756ea2f3.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ec7c744135ffcbf6b78ebc0cce3a5aeaf5509503f60158c3bfa96ce7d859f598.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/26686224aab9560ece6c58ab2370d4a34584ae3eb173400e691d2490756ea2f3.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ec7c744135ffcbf6b78ebc0cce3a5aeaf5509503f60158c3bfa96ce7d859f598.jpeg",
  location: "Warren, PA, USA",
  minimumOrderDollars: 104,
  rating: 5,
  reviewCount: 3,
  isTopShop: true,
  isInsider: true,
  description:
    "Welcome to AO! We are a women (and veteran) owned outfitter and outdoors store in northwest Pennsylvania that helps thousands of people of all skill levels and abilities plan and tackle canoe and kayak trips every summer. We have a deep love for the mighty Allegheny River and surrounding Allegheny National Forest - one of Pennsylvania's best kept secrets, and its only National Forest! \n\nAlong with helping folks find a meaningful connection with nature, we find it important to do the same in our own lives. From backpacking and paddling in our own backyard, to traveling across the US and abroad, our love of conservation, exploring, and learning knows no bounds.\n\nWe love to dabble in creating our own designs - those experiences and places that were special along the way - whether it be stickers, trail posters, or our clothing line Find Your Outside Voice!™, inspired by our own adventures over the years. ",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:16.391Z",
    importedBy: "entity-db-cli",
  },
};
